"use client"

import { useState, useEffect } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { Building2 } from "lucide-react"

export function Preloader() {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 2000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-zinc-950"
        >
          <div className="absolute inset-0 bg-gradient-to-b from-brand/10 via-transparent to-brand/10" />
          
          <div className="relative">
            <motion.div
              className="absolute inset-0 -m-8 rounded-full border border-brand/30"
              animate={{ 
                scale: [1, 1.2, 1],
                opacity: [0.3, 0.1, 0.3]
              }}
              transition={{ 
                duration: 2, 
                repeat: Infinity,
                ease: "easeInOut"
              }}
              style={{ width: 160, height: 160 }}
            />
            
            <motion.div
              className="absolute inset-0 -m-4 rounded-full border border-brand/40"
              animate={{ 
                scale: [1, 1.1, 1],
                opacity: [0.4, 0.2, 0.4]
              }}
              transition={{ 
                duration: 1.5, 
                repeat: Infinity,
                ease: "easeInOut",
                delay: 0.2
              }}
              style={{ width: 136, height: 136 }}
            />

            <motion.div
              className="absolute inset-0 -m-2 rounded-full"
              style={{ 
                width: 120, 
                height: 120,
                background: "conic-gradient(from 0deg, transparent, rgba(217,119,6,0.2), transparent, rgba(217,119,6,0.1), transparent)"
              }}
              animate={{ rotate: 360 }}
              transition={{ 
                duration: 3, 
                repeat: Infinity,
                ease: "linear"
              }}
            />

            <motion.div
              className="relative w-24 h-24 rounded-2xl overflow-hidden bg-brand shadow-2xl flex items-center justify-center"
              animate={{ 
                rotateY: [0, 360],
              }}
              transition={{ 
                duration: 3, 
                repeat: Infinity,
                ease: "easeInOut"
              }}
              style={{
                transformStyle: "preserve-3d",
                perspective: 1000
              }}
            >
              <Building2 className="w-12 h-12 text-white" />
            </motion.div>

            <motion.div
              className="absolute inset-0 rounded-2xl"
              style={{
                background: "radial-gradient(circle, rgba(217,119,6,0.2) 0%, transparent 70%)",
                filter: "blur(20px)"
              }}
              animate={{ 
                opacity: [0.3, 0.6, 0.3],
                scale: [1, 1.2, 1]
              }}
              transition={{ 
                duration: 2, 
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </div>

          <motion.div
            className="absolute bottom-1/3 flex flex-col items-center gap-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <div className="flex items-center gap-2">
              <span className="text-xl font-bold text-zinc-100">بنايه</span>
              <span className="text-brand">للعقارات</span>
            </div>
            
            <div className="flex gap-1">
              {[0, 1, 2].map((i) => (
                <motion.div
                  key={i}
                  className="w-2 h-2 rounded-full bg-brand"
                  animate={{ 
                    opacity: [0.3, 1, 0.3],
                    scale: [0.8, 1, 0.8]
                  }}
                  transition={{ 
                    duration: 1, 
                    repeat: Infinity,
                    delay: i * 0.2
                  }}
                />
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
